import React, { useContext } from "react";

import AccordionList from 'components/AccordionList';
import { useAccordionListQuery } from 'hooks/useAccordionListQuery';
import { PersonalizationContext } from 'components/Personalization/PersonalizationContext';

const AccordionListProvider = ({ id }) => {
	const { matchAudience } = useContext(PersonalizationContext);
	const { data } = useAccordionListQuery({ id });
	if (!!data && data.hasOwnProperty('Audience') && data?.Audience) {
		if (!matchAudience(data?.Audience)) {
			return null;
		}
	}
	return <AccordionList {...data} matchAudience={matchAudience} />;
};

export default AccordionListProvider;